export const CampaignRelatedToEnum = [
    { id: 1, name: 'Developer' },
    { id: 2, name: 'Community' },
    { id: 3, name: 'SubCommunity' },
    { id: 4, name: 'Property' },
    { id: 5, name: 'Unit' },
    { id: 6, name: 'GeneralCampaign' },
    { id: 7, name: 'City' },
  ]
